// extracted by mini-css-extract-plugin
export default {"header":"KioskHeader_header__9v0ty","logout":"KioskHeader_logout__dJCNd","item":"KioskHeader_item__YRxQ9"};